<template>
  <header>
    <am-header></am-header>
  </header>
  <div id="am-main-content">
    <router-view></router-view>
  </div>
  <footer style="border-top: 1px solid black;">
    <div class="container">
      <div class="row">
        <!--
        <div class="col-sm-6 cols-xs-12">
          <h3>What do we do at AllMac?</h3>
          <p style="font-size: 8px;">We engineer industry-leading production management software and integrated machine controls — including our flagship XL Series and Pathfinder controller solutions — that improve production efficiency and reduce downtime for roll forming and metal folding, and extend the useful operation life of your equipment.</p>
          <p><a v-link="{ path: '/about'}">Read more...</a></p>
        </div>
        -->
        <div class="col-sm-4 cols-xs-12">
          <h3>{{getStrRes('ML_LearnMoreAboutALLMAC')}}</h3>
          <ul class="nav nav-pills nav-stacked">
            <li>
              <a v-link="{ path: getUrlStr('/products/accessories') }">{{getStrRes('ML_Products')}}</a>
            </li>
            <li>
              <a v-link="{ path: getUrlStr('/oem') }">{{getStrRes('ML_OEM')}}</a>
            </li>
            <li>
              <a v-link="{ path: getUrlStr('/amscontrols/ams-xl200-ctrls') }">{{getStrRes('ML_AMSControls')}}</a>
            </li>
          </ul>
        </div>

        <div class="col-sm-4 cols-xs-12">
          <h3>{{getStrRes('ML_CoVNV')}}</h3>
          <p>{{getStrRes('ML_CoVNVPara01')}}</p>
          <p>{{getStrRes('ML_CoVNVPara02')}}<p>
          <p>{{getStrRes('ML_CoVNVPara03')}}</p>
        </div>
        
        <div class="col-sm-4 col-xs-12">
          <h3>{{getStrRes('ML_UpcomingNews')}}</h3>
          <p>
            <a href="https://www.metal-expo.ru/en" target="_blank">
              <img class="img-responsive" src="/assets/img/home/unews/unews-metalexpo2023.jpg">
            </a>
          </p>
          <p>
            <a href="https://www.metalcon.com/metalcon18/public/enter.aspx" target="_blank">
              <img class="img-responsive" src="/assets/img/home/unews/unews-metalcon2018.jpg">
            </a>
          </p>
          <p>
            <a href="https://www.euroblech.com/2018/{{getStrRes('ML_euroblechLang')}}" target="_blank">
              <img class="img-responsive" src="/assets/img/home/unews/unews-euroblech.jpg">
            </a>
          </p>
          <p>
            <a href="http://www.fabtechexpo.com/" target="_blank">
            <img v-if="isLangID('spa')" class="img-responsive" src="/assets/img/home/unews/unews-fabtech_spa.jpg">
            <img v-if="isLangID('de')" class="img-responsive" src="/assets/img/home/unews/unews-fabtech_de.jpg">
            <img v-if="isLangID('en')" class="img-responsive" src="/assets/img/home/unews/unews-fabtech.jpg">
            <img v-if="isLangID('ru')" class="img-responsive" src="/assets/img/home/unews/unews-fabtech.jpg">
            </a>
          </p>
        </div>
      </div>
      <div class="row">
          <div class="col-xs-12" style="text-align: center; margin-top: 5px;">
            {{getStrRes('ML_Copyright')}}
          </div>
      </div>
    </div>
  </footer>
</template>

<script>
import AmHeader from './components/main/AmHeader.vue'
import {getStrRes, getUrlStr, isLangID} from './util/MultiLang.js'
//English
const EN_STR_RES_MAP = new Map
EN_STR_RES_MAP.set("ML_LearnMoreAboutALLMAC", "Learn more About ALLMAC")
EN_STR_RES_MAP.set("ML_Products", "Products")
EN_STR_RES_MAP.set("ML_OEM", "OEM")
EN_STR_RES_MAP.set("ML_AMSControls", "AMS Controls")
EN_STR_RES_MAP.set("ML_CoVNV", "Company values and vision")
EN_STR_RES_MAP.set("ML_CoVNVPara01", "At ALLMAC we believe that providing our International customers with the most economical, accurate, efficient and highly reliable World class roll forming machinery is the best way to build on our strengths and experience, to create the maximum value for our customers and ourselves.")
EN_STR_RES_MAP.set("ML_CoVNVPara02", "Our eye is on the long term and we wish to be your roll forming partners into the future.")
EN_STR_RES_MAP.set("ML_CoVNVPara03", "We are looking forward to working with you to build your reputation as a reliable source of roll formed parts and our reputation as a reliable and trustworthy partner for roll forming machines.")
EN_STR_RES_MAP.set("ML_UpcomingNews", "Upcoming news")
EN_STR_RES_MAP.set("ML_euroblechLang", "english")
EN_STR_RES_MAP.set("ML_Copyright", "Copyright 2016 ALLMAC. Allrights reserved")

//Spanish
const SPA_STR_RES_MAP = new Map
SPA_STR_RES_MAP.set("ML_LearnMoreAboutALLMAC", "Más información sobre ALLMAC")
SPA_STR_RES_MAP.set("ML_Products", "Productos")
SPA_STR_RES_MAP.set("ML_OEM", "OEM")
SPA_STR_RES_MAP.set("ML_AMSControls", "Controles DE AMS")
SPA_STR_RES_MAP.set("ML_CoVNV", "Valores y visión de la empresa")
SPA_STR_RES_MAP.set("ML_CoVNVPara01", "En EL ALLMAC, creemos que proveer a nuestros clientes internacionales de la maquinaria de laminado de clase mundial más económica, precisa, eficiente y altamente confiable es la mejor manera de aprovechar nuestras fortalezas y experiencia, para crear el máximo valor para nuestros clientes y para nosotros mismos.")
SPA_STR_RES_MAP.set("ML_CoVNVPara02", "Nuestro ojo está en el largo plazo y deseamos ser su rodillo que forma socios en el futuro.")
SPA_STR_RES_MAP.set("ML_CoVNVPara03", "Estamos deseando trabajar con usted para construir su reputación como una fuente confiable de piezas conformadas en rollo y nuestra reputación como un socio confiable y confiable para máquinas de laminado.")
SPA_STR_RES_MAP.set("ML_UpcomingNews", "Noticias que vienen")
SPA_STR_RES_MAP.set("ML_euroblechLang", "espanol")
SPA_STR_RES_MAP.set("ML_Copyright", "Copyright 2016 ALLMAC. Todos los derechos reservados")

//de
const DE_STR_RES_MAP = new Map
DE_STR_RES_MAP.set("ML_LearnMoreAboutALLMAC", "Erfahren Sie mehr über ALLMAC")
DE_STR_RES_MAP.set("ML_Products", "Produkte")
DE_STR_RES_MAP.set("ML_OEM", "Erstausrüster")
DE_STR_RES_MAP.set("ML_AMSControls", "AMS Steuerungen")
DE_STR_RES_MAP.set("ML_CoVNV", "Firmenwerte und Visionen")
DE_STR_RES_MAP.set("ML_CoVNVPara01", "Bei ALLMAC glauben wir, dass es der beste Weg ist die für unsere internationalen Kunden wirtschaftlichste, präziseste, effizienteste und höchst zuverlässigste Rollformmaschinen zu liefern. ")
DE_STR_RES_MAP.set("ML_CoVNVPara02", "Unsere Augen richten sich auf die Langzeit und wir wünschen uns, dass wir Ihr Partner für Rollformen in der Zunkunft sind.")
DE_STR_RES_MAP.set("ML_CoVNVPara03", "Wir freuen uns auf die Zusammenarbeit mit Ihnen, um Ihren Ruf als eine verlässliche Quelle von rollgeformten Teilen und unseren Ruf als einen zuverlässigen und vertrauenswürdigen Partner für Rollformmaschinen aufzubauen.")
DE_STR_RES_MAP.set("ML_UpcomingNews", "Aktuelle Nachrichten")
DE_STR_RES_MAP.set("ML_euroblechLang", "deutsch")
DE_STR_RES_MAP.set("ML_Copyright", "Urheberrecht 2016 ALLMAC. Alle Rechte vorbehalten")

//ru
const RU_STR_RES_MAP = new Map
RU_STR_RES_MAP.set("ML_LearnMoreAboutALLMAC", "Узнайте больше об ALLMAC INDUSTRIES CO., LTD")
RU_STR_RES_MAP.set("ML_Products", "Продукция")
RU_STR_RES_MAP.set("ML_OEM", "Фирма-изготовитель комплектного оборудования")
RU_STR_RES_MAP.set("ML_AMSControls", "Управление AMS")
RU_STR_RES_MAP.set("ML_CoVNV", "Ценности и и перспективы компании")
RU_STR_RES_MAP.set("ML_CoVNVPara01", "ALLMAC INDUSTRIES CO., LTD считает, что поставка нашим международным клиентам наиболее экономичной, точной, эффективной и надежной роликовой профилировочной машины мирового класса является это лучшим способом создания максимальной ценности для наших клиентов и для нас самих, опираясь на наш опыт и преимущества.")
RU_STR_RES_MAP.set("ML_CoVNVPara02", "Мы нацелены на долгосрочную перспективу и надеемся стать вашим долгосрочным партнером в будущем.")
RU_STR_RES_MAP.set("ML_CoVNVPara03", "Мы будем рады сотрудничать с Вами, чтобы укрепить Вашу репутацию как надежного поставщика роликовых профилировочных элементов, надежного и добросовестного сотруднического партнера роликовой профилировочной машины.")
RU_STR_RES_MAP.set("ML_UpcomingNews", "Предстоящие новости")
RU_STR_RES_MAP.set("ML_euroblechLang", "russian")
RU_STR_RES_MAP.set("ML_Copyright", "Авторские права 2016 ALLMAC INDUSTRIES CO., LTD. Все права защищены.")

const MULTI_LANG_STR_RES_MAP = new Map
MULTI_LANG_STR_RES_MAP.set("en", EN_STR_RES_MAP)
MULTI_LANG_STR_RES_MAP.set("spa", SPA_STR_RES_MAP)
MULTI_LANG_STR_RES_MAP.set("de", DE_STR_RES_MAP)
MULTI_LANG_STR_RES_MAP.set("ru", RU_STR_RES_MAP)

export default {
  data() {
    return {
      mlStrResMap: MULTI_LANG_STR_RES_MAP
    }
  },
  components: {
    AmHeader
  }, methods: {
    getStrRes,
    getUrlStr,
    isLangID
  }
}
</script>

<style>
  html, body {
    height: 100%;
  }
  body {
    font-family: Helvetica, sans-serif;
    display: flex;
    flex-direction: column;
  }
  header {
    flex: 0 0 auto;
  }
  #am-main-content {
    flex: 1 0 auto;
  }
  footer {
    flex: 0 0 auto;
  }
</style>


// WEBPACK FOOTER //
// App.vue?fb40199a